/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeletePromptRequest = {
  id: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const DeletePromptRequest$inboundSchema: z.ZodType<
  DeletePromptRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type DeletePromptRequest$Outbound = {
  id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const DeletePromptRequest$outboundSchema: z.ZodType<
  DeletePromptRequest$Outbound,
  z.ZodTypeDef,
  DeletePromptRequest
> = z.object({
  id: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function deletePromptRequestToJSON(
  deletePromptRequest: DeletePromptRequest,
): string {
  return JSON.stringify(
    DeletePromptRequest$outboundSchema.parse(deletePromptRequest),
  );
}
export function deletePromptRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeletePromptRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeletePromptRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeletePromptRequest' from JSON`,
  );
}
